<!-- <div class="kt-demo-panel-overlay"></div>
<div id="kt_demo_panel" class="kt-demo-pane"> -->
<kt-base-modal [title]="'Shift Details'">
  <div modal-body>
    <div class="scroll-body">
      <!-- <div class="kt-demo-panel-overlay"></div> -->
      <div>
        <!-- <div>
              <div class="d-flex align-items-center">
                  <a (click)="hideClickHandler()" class="kt-demo-panel__close me-3 white-config-color-hover"
                      href="javascript:;" id="kt-demo-panel_close_btn">
                      <svg-icon class="svg_icon13x13 " src="assets/media/iq-svg/without_circle/icon_set_3/left_arrow.svg"></svg-icon>
                  </a>
                  <h3 class="">
                      Shift Details
                  </h3>
              </div>
          </div> -->
        <div class="">

          <div class="aside-shift-details-accordion shift-panel">

            <ngb-accordion [activeIds]=" shiftAllInfo?.timesheet ?  'schedule2' : 'schedule'">
              <ngb-panel id="schedule" *ngIf="scheduleShiftDetails">
                <ng-template ngbPanelTitle>
                  <h4>Schedule</h4>
                  <div class="collaps-icon"></div>
                </ng-template>
                <ng-template ngbPanelContent>
                  <kt-shift-control-details (eOpenModal)="openModalHandler($event)" [shiftAllInfo]="shiftAllInfo"
                    [shiftDetails]="scheduleShiftDetails"></kt-shift-control-details>
                </ng-template>
              </ngb-panel>
              <ngb-panel id="schedule2" *ngIf="shiftAllInfo?.timesheet">
                <ng-template ngbPanelTitle>
                  <h4>Actual</h4>
                  <div class="collaps-icon"></div>
                </ng-template>
                <ng-template ngbPanelContent>
                  <kt-shift-control-actual-details [timesheetDetails]="shiftAllInfo.timesheet">
                  </kt-shift-control-actual-details>
                </ng-template>
              </ngb-panel>
            </ngb-accordion>
          </div>
          <div *ngIf="!shiftAllInfo?.timesheet">
            <button type="button" class="btn btn-success btn-block btn-sm" (click)="startShiftClickHandler()">Start
              Shift</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</kt-base-modal>
